import {
    SAVE_DISPOSITION_PAYMENT,
    SET_DISPOSITION_PAYMENT_SAVE_STATUS,
    SET_DISPOSITION_PAYMENT_DATA
} from "./FleetDispositionPaymentSaveType"

const saveDispositionPayment = (paymentInfo: any) => ({
    type: SAVE_DISPOSITION_PAYMENT,
    paymentInfo
})

const setDispositionPaymentSaveStatus = (status: any) => ({
    type: SET_DISPOSITION_PAYMENT_SAVE_STATUS,
    status
})

const setDispositionPaymentData = (paymentData: any) => ({
    type: SET_DISPOSITION_PAYMENT_DATA,
    paymentData
})

export {
    saveDispositionPayment,
    setDispositionPaymentSaveStatus,
    setDispositionPaymentData
}